'use strict';

var React = require('react');
var reactPopper = require('react-popper');
require('../../theme/breakpoints.js');
require('imask');
var useResizeObserver = require('../../hooks/useResizeObserver.js');
var useScrollListener = require('../../hooks/useScrollListener.js');
var useWindowResize = require('../../hooks/useWindowResize.js');

const useTooltip = ({ isControlled, isOpened, onOpenedChange, placement, target, tooltip, }) => {
    const targetRef = React.useRef(target);
    targetRef.current = target;
    const tooltipRef = React.useRef(tooltip);
    tooltipRef.current = tooltip;
    const [isHovered, setHovered] = React.useState(isControlled ? isOpened : false);
    const onMouseEnter = () => setHovered(true);
    const onMouseLeave = () => setHovered(false);
    React.useEffect(() => {
        if (isControlled)
            return;
        target?.addEventListener('mouseenter', onMouseEnter);
        target?.addEventListener('mouseleave', onMouseLeave);
        return () => {
            target?.removeEventListener('mouseenter', onMouseEnter);
            target?.removeEventListener('mouseleave', onMouseLeave);
        };
    }, [target, isControlled]);
    React.useEffect(() => {
        onOpenedChange(isHovered);
    }, [isHovered]);
    const { styles, forceUpdate } = reactPopper.usePopper(target, tooltip, {
        strategy: 'absolute',
        placement: popperPlacement[placement],
    });
    const forceUpdateTooltipPosition = React.useCallback(() => forceUpdate?.(), [forceUpdate]);
    useResizeObserver.useResizeObserver({
        elementRefs: [targetRef, tooltipRef],
        observer: forceUpdateTooltipPosition,
    });
    useScrollListener.useScrollListener({
        elementRef: targetRef,
        listener: forceUpdateTooltipPosition,
    });
    useWindowResize.useWindowResize({ listener: forceUpdateTooltipPosition });
    React.useEffect(() => {
        if (isOpened)
            forceUpdateTooltipPosition();
    }, [isOpened, forceUpdateTooltipPosition]);
    return { style: styles.popper };
};
const popperPlacement = {
    'top-left': 'top-start',
    top: 'top',
    'top-right': 'top-end',
    'bottom-left': 'bottom-start',
    bottom: 'bottom',
    'bottom-right': 'bottom-end',
    'left-top': 'left-start',
    left: 'left',
    'left-bottom': 'left-end',
    'right-top': 'right-start',
    right: 'right',
    'right-bottom': 'right-end',
};

exports.useTooltip = useTooltip;
//# sourceMappingURL=useTooltip.js.map
